const tableColumns = [
    {
        title: "Sr No"
    },
    {
        title: "Source"
    },
    {
        title: "Destination"
    },
    {
        title: "Train/Flight/Roads"
    },
    {
        title: "Distance"
    },
    {
        title: "Duration"
    },
    {
        title: "Time"
    },
    {
        title: "Cost"
    }
];

export default tableColumns;